import { IconModel } from '../icon.model';
import { LocalizedValueModel } from '../localized-value.model';
import { NavigationItem } from '../navigation.model';
import { PermissionModel } from '../permissions';
import { ApplicationSharingPresenter } from './application-sharing-presnter-model';

export class DataModulePresenterModel {
  icon?: IconModel;
  normalizedName: string;
  isImplicit: boolean;
  id?: string;
  name: LocalizedValueModel;
  description?: LocalizedValueModel;
  specificationVersion?: number;
  permissions?: Array<PermissionModel>;
  sharing: ApplicationSharingPresenter;
}

/** Lite model of DataModulePresenterModel with view-items */
export interface DataModuleWithViewItems
  extends Pick<DataModulePresenterModel, 'id' | 'name' | 'icon'> {
  views?: NavigationItem[];
}

export type LiteDataModulePresenterModel = Pick<
  DataModulePresenterModel,
  'id' | 'name' | 'icon' | 'specificationVersion'
>;
